module.exports = __webpack_public_path__ + "img/icon-seek-forward.6a1d938f.svg";